(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-product-information"] && !Shopify.designMode) return;
  try {
    
  function connectCleanBuyNow(){
    document.querySelectorAll('.clean-buy-now').forEach(button=>{
      if(button.dataset.connected)return;
      button.dataset.connected='true';
      const scope=button.closest('.shopify-section');
      const form=scope.querySelector('form[data-type="add-to-cart-form"]');
      const addButton=form?.querySelector('[name="add"]');
      if(!form||!addButton)return;
      let busy=false;
      const sync=()=>{button.disabled=busy||addButton.disabled||addButton.getAttribute('aria-disabled')==='true';};
      new MutationObserver(sync).observe(addButton,{attributes:true,attributeFilter:['disabled','aria-disabled']});
      sync();
      button.addEventListener('click',async()=>{
        if(busy||button.disabled||!form.reportValidity())return;
        const error=scope.querySelector('.clean-buy-error');
        error.hidden=true;
        const data=new FormData(form);
        data.delete('sections');data.delete('sections_url');
        busy=true;sync();button.setAttribute('aria-busy','true');
        try{
          const response=await fetch(button.dataset.addUrl+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
          const result=await response.json();
          if(!response.ok||result.status)throw new Error(result.description||result.message||'Unable to add this item. Please try again.');
          window.location.assign(button.dataset.checkoutUrl);
        }catch(reason){error.textContent=reason.message;error.hidden=false;busy=false;sync();button.removeAttribute('aria-busy');}
      });
    });
  }
  function splitCleanContent(root){
    const source=root.querySelector('[data-clean-description]');
    const details=root.querySelector('[data-clean-details]');
    const care=root.querySelector('[data-clean-care]');
    if(!source||!details||!care)return;
    const fragment=document.createElement('div');
    fragment.innerHTML=source.innerHTML;
    fragment.querySelectorAll('script,style,iframe,[id="gtx-trans"]').forEach(node=>node.remove());
    const groups={description:[],details:[],care:[]};
    let category='description';
    const classify=text=>{
      const value=text.trim().replace(/[:：]$/,'');
      if(/^(?:materials?\s*(?:&|and)\s*care|care(?:\s+instructions)?|cleaning(?:\s+instructions)?|maintenance|养护|保养|清洁)$/i.test(value))return 'care';
      if(/^(?:details|product details|specifications?|dimensions?|measurements?|size|weight|materials?|technical details|产品详情|规格|尺寸|材质)$/i.test(value))return 'details';
      return 'description';
    };
    const labelCategory=text=>{
      if(/^(?:care|cleaning|maintenance|养护|保养|清洁)\s*[:：]/i.test(text))return 'care';
      if(/^(?:material|stone|dimensions?|size|weight|finish|color|colour|capacity|材质|石种|尺寸|重量|颜色)\s*[:：]/i.test(text))return 'details';
      return null;
    };
    const walk=node=>{
      if(node.nodeType===3){if(node.textContent.trim()){const p=document.createElement('p');p.textContent=node.textContent.trim();groups[category].push(p);}return;}
      if(node.nodeType!==1)return;
      const text=node.textContent.trim();
      if(/^H[1-6]$/.test(node.tagName)||((node.tagName==='P'||node.tagName==='DIV')&&node.querySelector(':scope > strong,:scope > b')&&text===node.querySelector(':scope > strong,:scope > b').textContent.trim())){
        category=classify(text);
        if(category==='description'){const h=document.createElement('h3');h.textContent=text;groups.description.push(h);}
        return;
      }
      if(node.tagName==='TABLE'){
        const table=node.cloneNode(true);
        table.querySelectorAll('tr').forEach(row=>{if(labelCategory(row.textContent.trim())==='care'||/^(?:care|cleaning|maintenance)\b/i.test(row.textContent.trim())){const p=document.createElement('p');p.textContent=Array.from(row.cells).map(cell=>cell.textContent.trim()).join(': ');groups.care.push(p);row.remove();}});
        if(table.querySelector('td'))groups.details.push(table);return;
      }
      if(node.tagName==='UL'||node.tagName==='OL'){
        Array.from(node.children).forEach(item=>{const target=labelCategory(item.textContent.trim())||category;let list=groups[target][groups[target].length-1];if(!list||list.tagName!==node.tagName){list=document.createElement(node.tagName.toLowerCase());groups[target].push(list);}list.append(item.cloneNode(true));});return;
      }
      if(node.tagName==='P'){
        const target=labelCategory(text)||category;
        if(text||node.querySelector('img,video'))groups[target].push(node.cloneNode(true));return;
      }
      if(['IMG','VIDEO','FIGURE','PICTURE'].includes(node.tagName)){groups.description.push(node.cloneNode(true));return;}
      Array.from(node.childNodes).forEach(walk);
    };
    Array.from(fragment.childNodes).forEach(walk);
    source.replaceChildren(...groups.description);
    details.replaceChildren(...groups.details);
    if(groups.care.length)care.replaceChildren(...groups.care);
    const hasContent=nodes=>nodes.some(node=>node.textContent.trim()||node.querySelector('img,video'));
    root.querySelector('[id^="CleanDetailsTab-"]').hidden=!hasContent(groups.details);
  }
  function connectCleanInformation(){
    document.querySelectorAll('.clean-information').forEach(root=>{
      if(root.dataset.connected)return;
      root.dataset.connected='true';
      splitCleanContent(root);
      const tabs=Array.from(root.querySelectorAll('[role=tab]:not([hidden])'));
      const activate=tab=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;root.querySelector('#'+item.getAttribute('aria-controls')).hidden=!selected;});};
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',event=>{
          let target;
          if(event.key==='ArrowRight')target=tabs[(index+1)%tabs.length];
          if(event.key==='ArrowLeft')target=tabs[(index+tabs.length-1)%tabs.length];
          if(event.key==='Home')target=tabs[0];
          if(event.key==='End')target=tabs[tabs.length-1];
          if(target){event.preventDefault();activate(target);target.focus();}
        });
      });
    });
  }
  const connectCleanProduct=()=>{connectCleanInformation();connectCleanBuyNow();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',connectCleanProduct);else connectCleanProduct();
  document.addEventListener('shopify:section:load',connectCleanProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kov-custom-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kov-custom-video')) {
  customElements.define('kov-custom-video', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const button = this.parentElement.querySelector('[data-video-toggle]');
      const desktop = this.querySelector('.kce__video-desktop');
      const mobile = this.querySelector('.kce__video-mobile');
      const media = window.matchMedia('(max-width:749px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const videos = [desktop, mobile].filter(Boolean);
      const active = () => media.matches ? mobile : desktop;
      const update = () => {
        const playing = active() && !active().paused;
        button.textContent = playing ? button.dataset.pause : button.dataset.play;
        button.setAttribute('aria-label', button.textContent);
      };
      const play = () => { const v = active(); if(v) {v.muted = true; v.play().then(update).catch(update);} };
      const switchVideo = () => { videos.forEach(v=>v.pause()); if(this.dataset.autoplay === 'true' && !reduced.matches) play(); update(); };
      button.addEventListener('click',()=>{const v=active();if(v.paused) play();else v.pause();update();},{signal});
      videos.forEach(v=>{v.addEventListener('play',update,{signal});v.addEventListener('pause',update,{signal});v.addEventListener('error',()=>{v.style.opacity='0';update();},{signal});});
      media.addEventListener('change',switchVideo,{signal});
      reduced.addEventListener('change',switchVideo,{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden) videos.forEach(v=>v.pause());},{signal});
      switchVideo();
    }
    disconnectedCallback() {if(this.abort)this.abort.abort();this.querySelectorAll('video').forEach(v=>v.pause());}
  });
}
if (!customElements.get('kov-custom-carousel')) {
  customElements.define('kov-custom-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.kce__track');
      const slides = [...this.querySelectorAll('.kce__slide')];
      const counter = this.querySelector('[data-counter]');
      const dots = [...this.querySelectorAll('[data-slide]')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, inView = false, hovering = false, touching = false;
      const interval = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
      const stop = () => {clearTimeout(this.timer);};
      const schedule = () => {
        stop();
        if(this.dataset.autoplay !== 'true' || reduced.matches || !inView || hovering || touching || document.hidden || this.contains(document.activeElement) || slides.length < 2) return;
        this.timer = setTimeout(() => go((index + 1) % slides.length), interval);
      };
      const go = target => {
        index = Math.max(0, Math.min(slides.length - 1, target));
        track.scrollTo({left:index * track.clientWidth,behavior:reduced.matches?'auto':'smooth'});
        schedule();
      };
      const update = () => {
        index = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth||1))));
        counter.textContent = (index+1)+' / '+slides.length;
        dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
        schedule();
      };
      dots.forEach(dot=>dot.addEventListener('click',()=>go(Number(dot.dataset.slide)),{signal}));
      track.addEventListener('scroll',update,{passive:true,signal});
      track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((index+(e.key==='ArrowRight'?1:-1)+slides.length)%slides.length);}},{signal});
      this.addEventListener('mouseenter',()=>{hovering=true;stop();},{signal});
      this.addEventListener('mouseleave',()=>{hovering=false;schedule();},{signal});
      this.addEventListener('pointerdown',()=>{touching=true;stop();},{signal});
      window.addEventListener('pointerup',()=>{touching=false;schedule();},{signal});
      window.addEventListener('pointercancel',()=>{touching=false;schedule();},{signal});
      this.addEventListener('focusin',stop,{signal});
      this.addEventListener('focusout',()=>setTimeout(schedule,0),{signal});
      document.addEventListener('visibilitychange',schedule,{signal});
      reduced.addEventListener('change',schedule,{signal});
      this.observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.25});
      this.observer.observe(this);
      this.resizeObserver=new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback(){clearTimeout(this.timer);if(this.abort)this.abort.abort();if(this.observer)this.observer.disconnect();if(this.resizeObserver)this.resizeObserver.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kov-custom-reference"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kov-reference-carousel')) {
  customElements.define('kov-reference-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.kcr__track');
      const slides = [...this.querySelectorAll('.kcr__slide')];
      const counter = this.querySelector('[data-counter]');
      const dots = [...this.querySelectorAll('[data-slide]')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, inView = false, hovering = false, touching = false;
      const interval = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
      const stop = () => {clearTimeout(this.timer);};
      const schedule = () => {
        stop();
        if(this.dataset.autoplay !== 'true' || reduced.matches || !inView || hovering || touching || document.hidden || this.contains(document.activeElement) || slides.length < 2) return;
        this.timer = setTimeout(() => go((index + 1) % slides.length), interval);
      };
      const go = target => {
        index = Math.max(0, Math.min(slides.length - 1, target));
        track.scrollTo({left:index * track.clientWidth,behavior:reduced.matches?'auto':'smooth'});
        schedule();
      };
      const update = () => {
        index = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth||1))));
        counter.textContent = (index+1)+' / '+slides.length;
        dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
        schedule();
      };
      dots.forEach(dot=>dot.addEventListener('click',()=>go(Number(dot.dataset.slide)),{signal}));
      track.addEventListener('scroll',update,{passive:true,signal});
      track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((index+(e.key==='ArrowRight'?1:-1)+slides.length)%slides.length);}},{signal});
      this.addEventListener('mouseenter',()=>{hovering=true;stop();},{signal});
      this.addEventListener('mouseleave',()=>{hovering=false;schedule();},{signal});
      this.addEventListener('pointerdown',()=>{touching=true;stop();},{signal});
      window.addEventListener('pointerup',()=>{touching=false;schedule();},{signal});
      window.addEventListener('pointercancel',()=>{touching=false;schedule();},{signal});
      this.addEventListener('focusin',stop,{signal});
      this.addEventListener('focusout',()=>setTimeout(schedule,0),{signal});
      document.addEventListener('visibilitychange',schedule,{signal});
      reduced.addEventListener('change',schedule,{signal});
      this.observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.25});
      this.observer.observe(this);
      this.resizeObserver=new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback(){clearTimeout(this.timer);if(this.abort)this.abort.abort();if(this.observer)this.observer.disconnect();if(this.resizeObserver)this.resizeObserver.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
